import { render } from "./SyncStatus.vue?vue&type=template&id=270f02ea&scoped=true"
import script from "./SyncStatus.vue?vue&type=script&lang=js"
export * from "./SyncStatus.vue?vue&type=script&lang=js"

import "./SyncStatus.vue?vue&type=style&index=0&id=270f02ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270f02ea"]])

export default __exports__